import React, { Component } from 'react';
import $ from 'jquery';
import DataTablesCreate from "./DataTablesCreate";

let headers = [
    {title: 'Tipo docuemnto'},//0
    {title: 'Folio'},//1
    {title: 'DocNum'},//2
    {title: 'Fecha de vencimiento'},//3
    {title: 'Estatus'},//4
    ];

class PaymentStatusListModal extends Component {

    closeTransaction = async () => {
        const {CancelRelatedCFDI} = this.props;
        await CancelRelatedCFDI(false);
    }

    close = async () => {
        const { cleanData } = this.props;
        $('#paymentStatusListModal').modal('hide');
        await  cleanData();
    }


    render() {
        const {data, ContinueToCancel, CancelPayments, SearchPayment} = this.props;


        if(data.length === 0){
            return <div className="modal fade bd-example-modal-lg bgtransparent"  role="dialog"  id="paymentStatusListModal"></div>;
        }


        return (
            <div>
                <div className="modal fade bd-example-modal-lg modal-open scroll" data-backdrop="static"  role="dialog"  id="paymentStatusListModal" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-open" role="document">
                        <div className="modal-content">

                            <div className="modal-header text-white" style={{backgroundColor:'#343a40',borderRadius:'0'}}>
                                <h4 className="modal-title" id="modal-basic-title ">Documentos relacionados</h4>
                                <button type="button" className="close" onClick={this.close} aria-label="Close">
                                    <span className="text-white" aria-hidden="true">&times;</span>
                                </button>
                            </div>

                            <div className="modal-body">
                                <div className="contanier">
                                    <div className="row justify-content-around">
                                        <div className="col-12">
                                            <div  className="w-100 table-scroll tab-pane fade show active "  aria-labelledby="nav-home-tab-Contenido" >
                                                <table className="table response" style={{marginBottom: 0}}>
                                                    <tbody>
                                                    <DataTablesCreate data={data} headers={headers} view={"paymentStatusListModal"} action={SearchPayment}/>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PaymentStatusListModal;